import useInfo from './useInfo';
import CustomerInfoModal from './modal';

const CustomerInfoPage = ({ id, open, onClose, onSave }) => {
  const viewModel = useInfo(id);

  const handleClose = () => {
    if (onClose) onClose();
  };

  const handleSave = async () => {
    await viewModel.onCustomerSave();
    if (onSave) onSave();
  };

  return (
    <CustomerInfoModal
      viewModel={viewModel}
      open={open}
      onClose={handleClose}
    />
  );
};

export default CustomerInfoPage;
